export function daysOfWeek(language: string) {
  if (language === "EN") {
    return [
      [1, "Monday", "Monday"],
      [2, "Tuesday", "Tuesday"],
      [3, "Wednesday", "Wednesday"],
      [4, "Thursday", "Thursday"],
      [5, "Friday", "Friday"],
      [6, "Saturday", "Saturday"],
      [7, "Sunday", "Sunday"],
    ];
  }
  if (language === "FR") {
    return [
      [1, "Lundi", "Lundis"],
      [2, "Mardi", "Mardis"],
      [3, "Mercredi", "Mercredis"],
      [4, "Jeudi", "Jeudis"],
      [5, "Vendredi", "Vendredis"],
      [6, "Samedi", "Samedis"],
      [7, "Dimanche", "Dimanches"],
    ];
  }
  if (language === "IT") {
    return [
      [1, "Lunedì", "Lunedì"],
      [2, "Martedì", "Martedì"],
      [3, "Mercoledì", "Mercoledì"],
      [4, "Giovedì", "Giovedì"],
      [5, "Venerdì", "Venerdì"],
      [6, "Sabato", "Sabato"],
      [7, "Domenica", "Domenica"],
    ];
  }
  return [
    [1, "Monday", "Monday"],
    [2, "Tuesday", "Tuesday"],
    [3, "Wednesday", "Wednesday"],
    [4, "Thursday", "Thursday"],
    [5, "Friday", "Friday"],
    [6, "Saturday", "Saturday"],
    [7, "Sunday", "Sunday"],
  ];
}

export function daysOfMonth() {
  return [
    [1, 1],
    [2, 2],
    [3, 3],
    [4, 4],
    [5, 5],
    [6, 6],
    [7, 7],
    [8, 8],
    [9, 9],
    [10, 10],
    [11, 11],
    [12, 12],
    [13, 13],
    [14, 14],
    [15, 15],
    [16, 16],
    [17, 17],
    [18, 18],
    [19, 19],
    [20, 20],
    [21, 21],
    [22, 22],
    [23, 23],
    [24, 24],
    [25, 25],
    [26, 26],
    [27, 27],
    [28, 28],
    [29, 29],
    [30, 30],
    [31, 31],
  ];
}
